import { render, staticRenderFns } from "./EsgDisclosureList.vue?vue&type=template&id=76ca7fa2"
import script from "./EsgDisclosureList.vue?vue&type=script&lang=js"
export * from "./EsgDisclosureList.vue?vue&type=script&lang=js"
import style0 from "./EsgDisclosureList.vue?vue&type=style&index=0&id=76ca7fa2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports